import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { callProcedure } from 'core/classes/helpers/callProcedure'
import Logger from 'core/utils/Logger'

interface IParams {
  partnerId: string
  fYear: number
  programType: ProgramTypes
}

export const fetchPlanningWizardSteps = async ({
  partnerId,
  fYear,
  programType,
}: IParams): Promise<string> => {
  try {
    const data = await callProcedure('spJBPPlanningWizardSteps', {
      'p.PartnerID': partnerId,
      'p.FYear': fYear,
      'p.ProgramType': programType,
    })

    return data[0].Data ?? ''
  } catch (e) {
    Logger.log(e)

    return ''
  }
}
